<template>
  <div id="main-body">
    <div id="sidebar">
      <slot name="sidebar"></slot>
    </div>
    <div id="calendar-boxed">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppBody",
};
</script>
